import {observer} from "mobx-react"
import {App} from "./App"
import {StsCreatePage, StsDetailPage, StsOverviewPage} from "../page/sts";

const StsApp = observer(function StsApp({mode}: {mode: 'overview' | 'create' | 'detail'}) {
    return <App>
        {mode === 'overview' && <StsOverviewPage />}
        {mode === 'detail' && <StsDetailPage />}
        {mode === 'create' && <StsCreatePage />}
    </App>
})

export {
    StsApp
}
